module.exports = __webpack_public_path__ + "static/media/image.74b44886.svg";